import { render, staticRenderFns } from "./QuestionNumberOptions.vue?vue&type=template&id=53ccb8a0&scoped=true"
import script from "./QuestionNumberOptions.vue?vue&type=script&lang=js"
export * from "./QuestionNumberOptions.vue?vue&type=script&lang=js"
import style0 from "./QuestionNumberOptions.vue?vue&type=style&index=0&id=53ccb8a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ccb8a0",
  null
  
)

export default component.exports